import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface PrivacyModalProps {
  onOpen: boolean
  onClose: () => void
}

export const PrivacyModal = ({ onOpen, onClose }: PrivacyModalProps) => {
  return (
    <F0Dialog isOpen={onOpen} onClose={onClose} title={i18n.t('meetings.prejoin.privacy.title')}>
      <Box gap="s12">
        <Text.Normal size="200">{i18n.t('meetings.prejoin.privacy.content_1')}</Text.Normal>
        <Text.Normal size="200">{i18n.t('meetings.prejoin.privacy.content_2')}</Text.Normal>
      </Box>
    </F0Dialog>
  )
}
